import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-selector',
  standalone: true,
  imports: [NgbTooltip],
  templateUrl: './image-selector.component.html',
  styleUrl: './image-selector.component.scss'
})
export class ImageSelectorComponent {

  @ViewChild('imageSelector') fileUploader: ElementRef;

  //imageFile: File;
  imageFilename: string;
  imageDataUrl: string | ArrayBuffer;

  @Input() customClass: string = '';
  @Input() imageFile: File;
  @Output() imageFileChange = new EventEmitter<File>();

  async fileChanged($event: Event) {
    let input = $event.target as HTMLInputElement;
    let imageFile: File;
    let imageFilename: string;


    if (input.files && input.files.length) {
      imageFile = input.files[0];
      imageFilename = imageFile.name;
      this.imageFile = imageFile;
      this.imageFilename = imageFilename;

      let reader = new FileReader();

      reader.onload = () => {
        let rResult = reader.result;
        this.imageDataUrl = `url('${rResult as string}')`;;
      };

      this.imageFileChange.emit(this.imageFile);
      reader.readAsDataURL(this.imageFile);
    }
    
  }

  selector_click() {
    if (this.imageFile) {
      this.clearimageSelector();
    }
    else {
      this.fileUploader.nativeElement.click();
    }
    
  }

  clearimageSelector() {

    this.imageFile = null;
    this.fileUploader.nativeElement.value = null;
    this.imageFilename = '';
    this.imageDataUrl = '';
    this.imageFileChange.emit(null);
  }


}
